// Reusable Pipedrive identity chip — shows the raw Pipedrive PipelineId
// + StageId anchors that drive the Deal/Lead pipelines. Surfaced in the
// Data Lab (persons row, person/order detail) and Customer 360° so ops
// can always cross-reference back to Pipedrive during the migration.
//
// Renders inline; degrades to just "PL #x" if only one id is present.
export default function PipedriveIdChip({ pipelineId, stageId, shortVip, size = "sm", testid }) {
  if (pipelineId == null && stageId == null && !shortVip) return null;
  const dim = size === "xs" ? "text-[8.5px] px-1 py-[1px]" : "text-[10px] px-1.5 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded border border-teal-400/25 bg-teal-400/[0.05] text-teal-200 font-mono uppercase tracking-widest ${dim}`}
      data-testid={testid || "pipedrive-id-chip"}
      title={`Pipedrive · Pipeline ${pipelineId ?? "—"} · Stage ${stageId ?? "—"}${shortVip ? ` · ${shortVip}` : ""}`}
    >
      {pipelineId != null && <span>PL#{pipelineId}</span>}
      {pipelineId != null && stageId != null && <span className="opacity-40">·</span>}
      {stageId != null && <span>ST#{stageId}</span>}
      {shortVip && (
        <>
          <span className="opacity-40">·</span>
          <span>{shortVip}</span>
        </>
      )}
    </span>
  );
}
